/// <amd-module name="Feed/Connect/Tool" />
import * as React from "react";

import { IPageData } from "VSS/Platform/Page";

import { IImageProps } from "VSSUI/Image";
import { IAnchorProps } from "VSSUI/Link";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { IProtocol } from "./Protocol";

export enum ToolId {
    DotNet,
    NuGet,
    VisualStudio,
    npm,
    Maven,
    Gradle,
    pip,
    twine,
    UniversalPackages,
    Ivy
}

export interface ITool {
    readonly id: ToolId;
    readonly name: string;
    readonly protocolName: string;
    readonly allowNonMembers: boolean;
    readonly imageProps: IImageProps;
    readonly featureFlag?: string;

    supportsGet(feed: IUxFeedView): boolean;
    supportsPush(feed: IUxFeedView): boolean;
    isEnvironmentSupported(pageData: IPageData): boolean;

    getToolLink?: () => IAnchorProps & { children?: React.ReactNode };
    getFeedUrl(packagingService: PackagingService, feed: IUxFeedView): string;
}

export abstract class PackagingTool implements ITool {
    protected constructor(
        readonly id: ToolId,
        public readonly name: string,
        private readonly protocol: IProtocol,
        public readonly imageProps: IImageProps,
        public readonly allowNonMembers: boolean = true
    ) {}

    public abstract getToolLink?: () => IAnchorProps & { children?: React.ReactNode };

    public get protocolName() {
        return this.protocol.name;
    }

    public get featureFlag() {
        return this.protocol.featureFlag;
    }

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        return this.protocol.getFeedUrl(packagingService, feed);
    }

    public supportsGet(feed: IUxFeedView): boolean {
        return true;
    }

    public supportsPush(feed: IUxFeedView): boolean {
        return feed.canPublishPackages;
    }

    public isEnvironmentSupported(pageData: IPageData): boolean {
        return true;
    }
}
